import { gql } from "@apollo/client";

export const USER_DATA = gql`
  fragment UserFields on user {
    userId
    firstName
    lastName
    phone
    email
    isStudent
    studentApplicantId
    birthDate
    joiningDate
    leavingDate
    address
    designation
    ctc
    department
    currentProject
    role
    orgId
    companyEmail
    gender
    maritalStatus
    employmentType
    imageUrl
    reportTo
    isActive
    bloodType
    emergencyContact
    portalRole
    hasAcceptedPolicies
    orgDetails {
      logo
      name
      address
      erpType
    }
    portalDetails {
      roleName
    }
    loginCheck
    salaryTemplateId
    roleDetails {
      name
    }
    deptDetails {
      name
      category
      deptId
    }
    typeofEmploymentDetails {
      name
      empId
    }
  }
`;
